<template>
  <div class="header" id="top">
    <!-- 预加载结束 -->
    <img :src="background" alt />
  </div>
</template>
<script>
export default {
  name: "banner",
  props: ["team"],
  computed: {
    background() {
      const name = this.team || "wolves";
      return require(`../../assets/images/${name}/banner.png`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/home";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="less">
@import "../../styles/home";
.header#top .cover {
  transition: all 0.16s ease-out;
  // background: no-repeat center/cover url("/static/images/wolves/banner.png");
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/section/banner.vue